import { Box, Typography } from "@material-ui/core";
import ToolkitTable from "components/Cards/Tables/ToolkitTable";
import LoadingData from "components/Loading/LoadingData";
import { columnTextField } from "utils/tables-utils";
import themeColorsDesingSystem from "assets/theme/ds-colors";
import {
  getTypeLabel,
  getStatusLabel,
  formatDate,
  TYPE_STYLE,
  STATUS_STYLE,
} from "../constants";
import ContentActionsMenu from "./content-actions-menu";

export default function ContentTable({
  data,
  loading,
  onAction,
  serverPagination,
  deletingRowKey,
}) {
  const columnModel = [
    columnTextField({
      dataField: "Titulo",
      text: "Conteúdo",
      headerAlign: "left",
      align: "left",
      formatter: (_, row) => (
        <Box style={{ display: "flex", alignItems: "center", gap: 20 }}>
          {row.Thumbnail ? (
            <img
              src={row.Thumbnail}
              alt={row.Titulo}
              style={{
                borderRadius: 10,
                width: 150,
                height: 75,
                objectFit: "cover",
              }}
            />
          ) : (
            <Box
              style={{
                borderRadius: 10,
                width: 150,
                height: 75,
                backgroundColor: themeColorsDesingSystem.stone.light,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Typography
                variant="caption"
                style={{ color: themeColorsDesingSystem.gray.main }}
              >
                Sem imagem
              </Typography>
            </Box>
          )}
          <Box>
            <Typography
              variant="subtitle2"
              style={{
                fontWeight: 600,
                color: themeColorsDesingSystem.text.primary,
              }}
            >
              {row.Titulo}
            </Typography>
          </Box>
        </Box>
      ),
    }),

    columnTextField({
      dataField: "Tipo",
      text: "Tipo",
      headerAlign: "left",
      align: "left",
      formatter: (_, row) => {
        const s = TYPE_STYLE[row.Tipo] || { bg: "#f5f5f5", color: "#616161" };
        return (
          <Box
            style={{
              display: "inline-block",
              padding: "4px 10px",
              borderRadius: 6,
              backgroundColor: s.bg,
              color: s.color,
              fontSize: "0.75rem",
              fontWeight: 600,
            }}
          >
            {getTypeLabel(row.Tipo)}
          </Box>
        );
      },
    }),
    columnTextField({
      dataField: "Categoria",
      text: "Categoria",
      headerAlign: "left",
      align: "left",
      formatter: (_, row) => (
        <Typography
          variant="body2"
          style={{ color: themeColorsDesingSystem.text.primary }}
        >
          {row.Categoria}
        </Typography>
      ),
    }),
    columnTextField({
      dataField: "Status",
      text: "Status",
      headerAlign: "left",
      align: "left",
      formatter: (_, row) => {
        const s = STATUS_STYLE[row.Status] || STATUS_STYLE.Rascunho;
        return (
          <Box
            style={{
              display: "inline-block",
              padding: "4px 10px",
              borderRadius: 6,
              backgroundColor: s.bg,
              color: s.color,
              fontSize: "0.75rem",
              fontWeight: 600,
            }}
          >
            {getStatusLabel(row.Status)}
          </Box>
        );
      },
    }),
    columnTextField({
      dataField: "Periodo",
      text: "Período",
      headerAlign: "left",
      align: "left",
      formatter: (_, row) => (
        <Typography
          variant="body2"
          style={{ color: themeColorsDesingSystem.text.primary }}
        >
          {row.Periodo || "-"}
        </Typography>
      ),
    }),
    columnTextField({
      dataField: "AtualizadoPor",
      text: "Atualizado por",
      headerAlign: "left",
      align: "left",
      formatter: (_, row) => (
        <Box>
          <Typography
            variant="body2"
            style={{ color: themeColorsDesingSystem.text.primary }}
          >
            {row.AtualizadoPor}
          </Typography>
          <Typography
            variant="caption"
            style={{ color: themeColorsDesingSystem.gray.main }}
          >
            {formatDate(row.DataAtualizacao)}
          </Typography>
        </Box>
      ),
    }),
    columnTextField({
      dataField: "acoes",
      text: "Ações",
      headerAlign: "center",
      align: "center",
      formatter: (_, row) => (
        <ContentActionsMenu
          row={row}
          onAction={onAction}
          disabled={!!deletingRowKey}
          deleting={deletingRowKey === row.rowKey}
        />
      ),
    }),
  ];

  if (loading) {
    return <LoadingData searching label="Carregando conteúdos..." />;
  }

  return (
    <ToolkitTable
      keyField="rowKey"
      dataTable={data}
      columnModel={columnModel}
      notFoundTitle="Nenhum conteúdo encontrado com os filtros aplicados."
      pagination={
        serverPagination
          ? null
          : {
              options: [10, 25, 50],
              defaultOption: 10,
              showTotal: true,
            }
      }
    />
  );
}
